/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newlycreated1Inputs */

const en_newlycreated1 = /** @type {(inputs: Newlycreated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newly created`)
};

const de_newlycreated1 = /** @type {(inputs: Newlycreated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu erstellt`)
};

/**
* | output |
* | --- |
* | "Newly created" |
*
* @param {Newlycreated1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const newlycreated1 = /** @type {((inputs?: Newlycreated1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newlycreated1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_newlycreated1(inputs)
	return de_newlycreated1(inputs)
});
export { newlycreated1 as "newlyCreated" }